import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AllServiceAreas from "./allServiceAreas";

export default function ServiceAreas() {
  const navigate = useNavigate();
  const { page } = useParams();

  useEffect(() => {
    if (!page) {
      navigate(`/admin/settings/service-areas/1`);
    }
    // eslint-disable-next-line
  }, [page]);

  return (
    <div data-test="service-areas-page">
      <AllServiceAreas />
    </div>
  );
}
